import { AlertVariant } from "uol-host-react-ui/dist/molecules/Alert/Alert.types"

export type VariantValues = {[key in AlertVariant]: {
    header: string,    
    description?: string
}}

export const variantValues: VariantValues = {
    'loader': {
        header: 'Carregando',
        description: 'Aguarde enquanto estamos carregando o conteúdo da página.'
    },
    'danger': {
        header: 'Erro!',
        description: 'Erro ao tentar processar a solicitação, tente novamente mais tarde.'
    },
    'block': {
        header: 'Bloqueado',        
    },
    'warning': {
        header: 'Atenção!',        
    },
    'info': {
        header: 'Informação'
    },
    'success': {
        header: 'Sucesso!'
    },
    'wait': {
        header: 'Por favor, aguarde'
    }
}